<template>
  <div class="app-container">
    <CrudTable entity="ParcelType" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'description',
        {
          field: 'alternativeParcelTypeDescription',
          label: 'parcelType.alternativeParcelType',
          sortable: false,
          filter: { type: 'none' }
        }
      ]
    };
  }
};
</script>

<style scoped></style>
